export default __webpack_public_path__ + "static/media/icon-minus.f5073aa8.svg";